import { Grid, Input, Stack, Text } from '@chakra-ui/react';
import { DropdownPopover } from 'modules/common/components/ToolbarPopover';
import { generateTranslatedOptions } from 'modules/common/components/ToolbarPopover/DropdownPopover';
import { ChangeEvent, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { DEFAULT_FORM_FIELD_VALUE, INPUT_TYPE_OPTIONS } from 'widgets/FormWidget/FormWidget.config';
import { FormWidgetData } from 'widgets/FormWidget/FormWidget.types';
import { useWidget } from 'widgets/sdk';

export const Fields = () => {
  const { t } = useTranslation('editor_widget_toolbar', { useSuspense: false, keyPrefix: 'formToolbar' });

  return (
    <Stack spacing={4} px={4}>
      <Grid templateColumns='1fr auto'>
        <Text fontSize='sm' color='font.500' fontWeight='medium'>
          {t('settingsSideBar.fieldType')}
        </Text>
        <InputTypeSelect />
      </Grid>
      <Grid templateColumns='1fr auto'>
        <Text fontSize='sm' color='font.500' fontWeight='medium'>
          {t('labelText')}
        </Text>
        <ValueInput />
      </Grid>
      <Grid templateColumns='1fr auto'>
        <Text fontSize='sm' color='font.500' fontWeight='medium'>
          {t('placeholder')}
        </Text>
        <PlaceholderInput />
      </Grid>
    </Stack>
  );
};

Fields.displayName = 'Fields';
export default Fields;

const ValueInput = () => {
  const {
    field: { label },
    updateWidget,
  } = useWidget<FormWidgetData>();
  const { t } = useTranslation('editor_widget_toolbar', { useSuspense: false, keyPrefix: 'formToolbar' });

  const updateValue = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => {
      updateWidget({ field: { label: e.target.value || '' } });
    },
    [updateWidget],
  );
  return <Input placeholder={t('name')} value={label} onChange={updateValue} size={'sm'} borderRadius='base' />;
};

const PlaceholderInput = () => {
  const {
    field: { placeholder },
    updateWidget,
  } = useWidget<FormWidgetData>();
  const { t } = useTranslation('editor_widget_toolbar', { useSuspense: false, keyPrefix: 'formToolbar' });

  const updateValue = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => {
      updateWidget({ field: { placeholder: e.target.value || '' } });
    },
    [updateWidget],
  );
  return (
    <Input placeholder={t('placeholder')} value={placeholder} onChange={updateValue} size={'sm'} borderRadius='base' />
  );
};

const InputTypeSelect = () => {
  const {
    field: { type },
    updateWidget,
  } = useWidget<FormWidgetData>();
  const { t } = useTranslation('editor_widget_toolbar', { useSuspense: false, keyPrefix: 'formToolbar' });
  const selectedIndex = INPUT_TYPE_OPTIONS.findIndex((option) => option.value === type);

  const onUpdateInputType = (type: string) => {
    const { value, placeholder } = DEFAULT_FORM_FIELD_VALUE[type as keyof typeof DEFAULT_FORM_FIELD_VALUE];
    updateWidget({ field: { type, placeholder, value } });
  };

  return (
    <DropdownPopover
      selectedIndex={selectedIndex}
      options={generateTranslatedOptions(t, INPUT_TYPE_OPTIONS, 'settingsSideBar')}
      label={t('settingsSideBar.fieldType')}
      w={'150px'}
      spacing={2}
      onSelect={onUpdateInputType}
      buttonVariant={'toolbar-dropdown-option'}
      optionsButtonVariant={'toolbar-dropdown-item-basic'}
      triggerSelectOnSameValue={false}
      useLabelInsteadOfSelectedLabel
      triggerProps={{
        height: 8,
      }}
      buttonOptionProps={{
        height: 7,
        justifyContent: 'flex-start',
      }}
    />
  );
};
